/* eslint-disable*/

import { faFileExcel, faFileWord, faFileImage, faFilePdf, faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef } from "react";
import { DownloadCloud, Trash, UploadCloud } from "react-feather";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardFooter, CardHeader, Form } from "reactstrap";
import SweetAlert from "sweetalert2";
import { useAuth } from "../../../context/AuthContext";
import useFetcher from "../../../hooks/useFetcher";
import { useFiles } from "../../../hooks/useFiles";
import useMutter from "../../../hooks/useMutter";
import { fetchFiles, removeFile, downloadFile } from "../../../services/fileServices";
import { handleErrors } from "../../../services/handleErrors";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { fetchInfoGeneralFilesByClientId } from "../../../services/informacionGeneral";

const FilemanagerInfoGeneral = forwardRef(
  (
    { bodyStyle, onChange, entity, entityId, scroll, editable = true, canDeleteFile = (file) => true, hideHeader, fileNameStyle, fileIconStyle, disclaimer, clientId },
    ref
  ) => {
    const { refreshToken } = useAuth();
    const filesDetail = useRef(null);
    const [files, isLoadingFiles, , , refreshFiles] = useFetcher(fetchInfoGeneralFilesByClientId, [clientId]);
    const [deleteFile, isLoadingDeleteFile] = useMutter(removeFile, [{ entity, entityId }]);
    const [isDownloadingFile, setIsDownloadingFile] = useState(false);
    const [isUploadingFiles, handleUploadFileButton, handleConfirmSelectedFiles] = useFiles();
    const scrollToBottom = () => {
      filesDetail.current.scrollIntoView({ behavior: "smooth" });
    };
    useEffect(() => {
      scrollToBottom();
    }, [files, scroll]);

    const handleFilesChanges = () => {
      if (onChange) {
        onChange();
      }
      refreshFiles();
    };
    useImperativeHandle(ref, () => ({
      refreshFiles,
    }));
    const getFileIconName = (mimetype) => {
      if (mimetype.includes("pdf")) {
        return faFilePdf;
      }
      if (mimetype.includes("msword") || mimetype.includes("officedocument.wordprocessingml.document") || mimetype.includes("opendocument.text")) {
        return faFileWord;
      }
      if (mimetype.includes("ms-excel") || mimetype.includes("officedocument.spreadsheetml.sheet") || mimetype.includes("opendocument.spreadsheet")) {
        return faFileExcel;
      }
      if (mimetype.includes("image")) {
        return faFileImage;
      }
      return faFile;
    };

    const handleRemoveFile = async (file) => {
      const { isConfirmed } = await SweetAlert.fire({
        title: `Borrar ${file.originalname}`,
        text: "¿Seguro que desea borrar el archivo?. Si continua no podrá recuperarlo.",
        icon: "warning",
        confirmButtonColor: "#bf0d3e",
        showCancelButton: true,
        showConfirmButton: true,
        dangerMode: true,
      });

      if (isConfirmed) {
        entity = file.FileRels.entity.charAt(0).toLowerCase() + file.FileRels.entity.slice(1);
        await deleteFile({ entity, entityId: file.FileRels.entityId, fileId: file.id });
        handleFilesChanges();
        toast.success(`Archivo ${file.originalname} borrado exitosamente`);
      }
    };

    const handleDownloadFile = async (file) => {
      setIsDownloadingFile(true);
      try {
        entity = file.FileRels.entity.charAt(0).toLowerCase() + file.FileRels.entity.slice(1);
        await downloadFile({ entity, entityId: file.FileRels.entityId, fileId: file.id });
        toast.success(`Archivo ${file.originalname} descargado exitosamente`);
      } catch (err) {
        handleErrors(err, toast.error, refreshToken);
      } finally {
        setIsDownloadingFile(false);
      }
    };

    const getFullNameByUser = (file) => {
      const { nombre, apellido } = file.usuario;
      return `${nombre} ${apellido}`;
    };

    return (
      <BlurSpinner isLoading={isLoadingFiles || isLoadingDeleteFile || isDownloadingFile || isUploadingFiles}>
        <Card className="h-100 mb-0">
          {hideHeader !== true && (
            <CardHeader className="pt-2 pb-2 d-flex justify-content-between align-items-center">
              <h6 className="m-1">Archivos:</h6>
              <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                <input
                  id="upfile"
                  type="file"
                  onChange={() => handleConfirmSelectedFiles({ entity, entityId, handleFilesUploaded: handleFilesChanges })}
                  multiple
                  accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
              </Form>
              {editable ? (
                <Button outline size="xs" onClick={handleUploadFileButton}>
                  <UploadCloud size="24" />
                </Button>
              ) : null}
            </CardHeader>
          )}

          <CardBody style={bodyStyle} className="file-body py-2 custom-scrollbar table-activity ">
            {disclaimer && (
              <h6 className="h-100 d-flex justify-content-center align-content-center flex-wrap">
                * Le recordamos que no puede subir información referida a los asociados.
              </h6>
            )}
            {files && files.length > 0 ? (
              <div className="new-users activity  ml-2 ">
                {files.map((file) => (
                  <div className="media" key={file.id}>
                    <div className="gradient-round m-r-30 gradient-line-1 file-icon" style={fileIconStyle}>
                      <FontAwesomeIcon icon={getFileIconName(file.mimetype)} />
                    </div>
                    <div className="media-body">
                      <h6 className="mb-1 f-w-700 text-break file-name" style={fileNameStyle}>
                        {file.originalname}
                      </h6>
                      <p className="file-creator">{file.usuario ? getFullNameByUser(file) : "No User"}</p>
                    </div>
                    <span className="pull-right file-actions">
                      {editable && canDeleteFile(file) ? (
                        <Button size="xs" color="link secondary" onClick={() => handleRemoveFile(file)}>
                          <Trash size="24" />
                        </Button>
                      ) : null}
                      <Button size="xs" outline className="btn-pill" onClick={() => handleDownloadFile(file)}>
                        <DownloadCloud size="24" />
                      </Button>
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="h-100 d-flex justify-content-center align-content-center flex-wrap">
                <h6>Aún no se han subido archivos</h6>
              </div>
            )}
            <div ref={filesDetail} />
          </CardBody>
          {hideHeader === true && editable && (
            <CardFooter className="p-1">
              <div className="input-group d-flex justify-content-center">
                <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                  <input
                    id="upfile"
                    type="file"
                    onChange={() => handleConfirmSelectedFiles({ entity, entityId, handleFilesUploaded: handleFilesChanges })}
                    multiple
                    accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                </Form>

                <Button outline size="xs" className="d-flex align-items-center" onClick={handleUploadFileButton}>
                  <span className="m-1 mr-2">
                    <UploadCloud size="24" />
                  </span>
                  Agregar Archivos
                </Button>
              </div>
            </CardFooter>
          )}
        </Card>
      </BlurSpinner>
    );
  }
);

export default FilemanagerInfoGeneral;
